import { ComponentPropsWithoutRef, ReactNode, useCallback } from 'react';

import classNames from 'classnames';
import { Command } from 'cmdk';

import { comboboxStyles } from '../combobox.styles';
import { useComboboxContext } from '../ComboboxContext';

export interface ComboboxOptionProps extends Omit<ComponentPropsWithoutRef<'div'>, 'value'> {
  children?: ReactNode;
  value: string;
  active?: boolean;
  disabled?: boolean;
}

export const ComboboxOption = ({
  className,
  children,
  value,
  active,
  disabled,
  ...rest
}: ComboboxOptionProps) => {
  const { classNames: contextClassNames, onOptionSubmit } = useComboboxContext();
  const styles = comboboxStyles();

  const handleSelect = useCallback(() => {
    if (disabled) return;
    onOptionSubmit?.(value);
  }, [disabled, value, onOptionSubmit]);

  return (
    <Command.Item
      {...rest}
      value={value}
      disabled={disabled}
      onSelect={handleSelect}
      data-combobox-option
      data-combobox-active={active || undefined}
      className={classNames(styles.option(), contextClassNames?.option, className)}
    >
      {children}
    </Command.Item>
  );
};
